import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { DeviceType } from '../../models/enums'
import DisplayFullScreenButton from '../AnswerPanel/DisplayFullScreenButton'

interface ImageAttachmentProps {
  url: string
  title?: string
  alt?: string
  isMiniature?: boolean
  height?: number
}

const ImageAttachment = ({ url, title, alt, isMiniature, height }: ImageAttachmentProps): JSX.Element => {
  const displaySubtitles = useSelector((state: RootState) => state.retorikReducer.displaySubtitles)
  const currentDeviceType = useSelector((state: RootState) => state.viewReducer.currentDeviceType)
  const currentHeight = useSelector((state: RootState) => state.viewReducer.currentHeight)
  const [maxHeight, setMaxHeight] = useState<number>(0)

  useEffect(() => {
    if (currentHeight && currentDeviceType) {
      switch (currentDeviceType) {
        case DeviceType.mobile:
        case DeviceType.widget:
          setMaxHeight(Math.floor(currentHeight * (displaySubtitles ? 0.34 : 0.5)))
          break
        case DeviceType.landscape:
          // The container in BotResponse is 7 rows high on the main grid, with a total of 12 rows, so quite 59%.
          // We reduce a little 9% because 100% is whithout browser's interface.
          setMaxHeight(Math.floor(currentHeight * 0.5))
          break
        case DeviceType.borne:
          // Same as landscape, but 5 rows high instead of 7
          setMaxHeight(Math.floor(currentHeight * 0.34))
          break
        default:
          break
      }
    }
  }, [currentHeight, currentDeviceType, displaySubtitles])

  return (
    <div
      className='rf-w-full rf-p-4 rf-flex rf-flex-row rf-items-center rf-justify-center rf-rounded rf-bg-cardFrameBackground'
      style={{
        height: height,
        touchAction: 'pan-y'
      }}
    >
      <DisplayFullScreenButton url={url} />
      {isMiniature ? (
        <React.Fragment>
          <div className='rf-w-1/4' />
          <img
            className='rf-max-w-1/2'
            src={url}
            alt={alt || 'image'}
            style={{
              maxHeight: `calc(${maxHeight}px - 3rem)`
            }}
          />
          <div className='rf-w-1/4' />
        </React.Fragment>
      ) : (
        <img
          className='rf-max-w-full'
          src={url}
          alt={alt || 'image'}
          style={{
            maxHeight: `calc(${maxHeight}px - 3rem)`
          }}
        />
      )}
      {title && (
        <div className='rf-absolute rf-bottom-0 rf-py-2 rf-text-center rf-text-sm large:rf-text-base rf-text-cardFrameText rf-bg-cardFrameBackground rf-bg-opacity-80 rf-rounded-b rf-w-full'>
          {title}
        </div>
      )}
    </div>
  )
}

export default ImageAttachment
